import { useContext, useState } from 'react';
import { OsContext } from '../../../context/OsContext';
import { Button, Modal } from 'react-bootstrap';
import { dialog, toastErro, toastSucesso } from '../../GestecSwall';

export default function RemoverAnexo({ os, item }) {
  const { deleteFile, listFiles } = useContext(OsContext);
  const [show, setShow] = useState(false);

  const handleRemove = async () => {

    if (!item?.id) {
      toastErro('Identificador do anexo não foi encontrado!');
      return;
    }

    const confirma = await dialog('Deseja realmente remover este anexo?');
    if (confirma.isConfirmed) {
      const response = await deleteFile({ id: item.id });
      if (response?.status === 200) {
        toastSucesso('Anexo removido com sucesso!');
        listFiles(os);
        setShow(false);
      } else {
        toastErro('Erro ao remover anexo! Entre em contato com o suporte!');
      }
    }
  };

  return (
    <>
      <Button onClick={handleRemove} className="btn btn-danger">
        <i className="ri-delete-bin-line"></i> <span>Excluir Imagem</span>
      </Button>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header>Excluir</Modal.Header>
        <Modal.Body></Modal.Body>
      </Modal>
    </>
  );
}